import { render } from "./Period.vue?vue&type=template&id=4281d53c&scoped=true"
import script from "./Period.vue?vue&type=script&lang=js"
export * from "./Period.vue?vue&type=script&lang=js"

import "./Period.vue?vue&type=style&index=0&id=4281d53c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4281d53c"]])

export default __exports__